import { Box, Menu, MenuItem } from "@mui/material";
import { useLanguageContext } from "../../context/languageContext";
import { useState } from "react";
import { languageOptions } from "../../data/textOfThePage";

export const HeaderMenuFlags = ({ movileType }) => {
  const { languageSelected, setLanguageSelected } = useLanguageContext();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenuClick = (event) => {
    setAnchorEl(event?.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box
      sx={{
        ml: 2,
        display: {
          xs: movileType ? "block" : "none",
          md: !movileType ? "block" : "none",
        },
      }}
    >
      <Box
        className="navbar-page"
        component="img"
        src={languageOptions[languageSelected].icon}
        sx={{
          height: "30px",
          display: "flex",
          justifyContent: "center",
        }}
        onClick={handleMenuClick}
      />
      <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
        {languageOptions.map((language, index) => (
          <MenuItem
            key={language.country}
            onClick={(value) => {
              handleMenuClose(value);
              setLanguageSelected(index);
            }}
          >
            <Box
              className="navbar-page"
              component="img"
              src={language.icon}
              sx={{
                width: "30px",
                height: "30px",
                display: "flex",
                justifyContent: "center",
                m: "0px",
              }}
            />
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};
